module.exports = __webpack_public_path__ + "img/novidades-inscricoes-regulamento.9d810468.png";